'use client';
import { useParams } from 'next/navigation';

import { useHasSubscription } from '~features/tags';

import { promoEventConfig } from '../config';
import { useIsPromoEventActive } from './useIsPromoEventActive';

export const useIsMembershipPromoEventActive = () => {
	const active = useIsPromoEventActive();
	const { recipientId = '' } = useParams<{ recipientId?: string }>();
	const [hasSubscription, isLoading] = useHasSubscription();

	const offersSpecialMembership =
		!!recipientId &&
		!hasSubscription &&
		promoEventConfig.offersSpecialMembership.enabled &&
		promoEventConfig.offersSpecialMembership.botId === +recipientId;

	return { active: !isLoading && active && offersSpecialMembership, isLoading };
};
